module.exports = __webpack_public_path__ + "img/image151.675b3de1.jpg";